import { useAtom } from 'jotai';
import { ColorSwatch, hexToRgba } from 'components/color-picker';
import { useDatasetAtoms } from './dataset-context';
import styles from './layer-color-picker.module.scss';

/**
 * Swatch + label for a dataset's layer color. Opens the shared HSV color
 * picker (hue/saturation, hex, and opacity) on click.
 * @return {JSX.Element} The inline color picker component.
 */
export const LayerColorPickerInline = ({ label }: { label?: string }) => {
  const atoms = useDatasetAtoms();
  const [color, setColor] = useAtom(atoms.layerColorAtom);

  return (
    <div
      className={styles.wrapper}
      onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
    >
      <ColorSwatch
        color={color}
        onChange={(newColor, newOpacity) =>
          setColor(hexToRgba(newColor, newOpacity))
        }
      />
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
};
